import React, { useRef } from 'react';
import './style.scss';

export interface FileReadProps {
  onFileRead: (file: File, content: string | ArrayBuffer | null) => void;
  accept?: string;
  multiple?: boolean;
  label?: string; // <-- Add this line
  className?: string;
}

const FileRead: React.FC<FileReadProps> = ({
  onFileRead,
  accept,
  multiple,
  label = 'Upload file',
  className = '',
}) => {
  const fileInput = useRef<HTMLInputElement | null>(null);

  const openFileDialog = () => {
    fileInput.current?.click();
  };

  const handleFileChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const files = ev.target.files;
    if (!files) return;

    Array.from(files).forEach((file) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const result = event.target?.result;
        onFileRead(file, result ?? null);
      };
      reader.readAsText(file);
    });

    ev.target.value = '';
  };

  return (
    <div
      className={`file-upload ${className}`}
      onClick={openFileDialog}
    >
      <input
        type="file"
        accept={accept}
        ref={fileInput}
        style={{ display: 'none' }}
        onChange={handleFileChange}
        multiple={multiple}
      />
      <span>{label}</span>
    </div>
  );
};

export default FileRead;
